import React from 'react';
const Home = () => {
  return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',lineHeight:'12'}}>
      <h1>Home Page</h1>
    </div>
  );
};

export default Home;
